import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, FormHelperText, InputAdornment, Tooltip, IconButton, Typography, Box } from '@mui/material';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { GridRowModel, GridRowModes, GridRowModesModel, useGridApiRef } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';

interface DialogFormProps {
    open: boolean;
    row: GridRowModel;
    user: any;
    onClose: () => void;
    apiRef: ReturnType<typeof useGridApiRef>;
}

export default function DialogForm({ open, row, user, apiRef, onClose }: DialogFormProps) {

    const [rowData, setRowData] = React.useState<{whisper: string, customer_name: string, entity_cust_id: string}>({
      whisper: row?.whisper?.toString() || '',
      customer_name: row?.customer_name?.toString() || '',
      entity_cust_id: row?.entity_cust_id?.toString() || '',
    });

    React.useEffect(() => {
      setRowData({
        whisper: row?.whisper?.toString() || '',
        customer_name: row?.customer_name?.toString() || '',
        entity_cust_id: row?.entity_cust_id?.toString() || '',
      });
    }, [row]);

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={open}
            onClose={onClose}
            slotProps={{
              paper: {
                component: 'form',
                onSubmit: async (event: React.SubmitEvent<HTMLFormElement>) => {
                  event.preventDefault();
                  const formData = new FormData(event.currentTarget);
                  const whisper = formData.get('whisper') as string;
                  const csrfToken = await axios.get('/csrf').then((response) => response.data.csrfToken);
                  const response = await axios.put(`/${user.role === 'Administrator' ? 'admin' : user.role === 'Executive' ? 'executive' : ''}/whisper/${row.id}/update/?entity_id=${localStorage.getItem('entity_id')}`, {
                    whisper: whisper,
                  }, {
                    headers: {
                      'X-CSRFToken': csrfToken,
                    },
                  });
                  if (response.status === 200) {
                    toast.success(response.data.message, { position: 'top-center', autoClose: 2000 });
                    setTimeout(() => {
                      apiRef.current?.updateRows([{
                        ...row,
                        whisper: whisper,
                      }]);
                      onClose();
                    }, 2100);
                  } else {
                    toast.error(response.data.message, { position: 'top-center', autoClose: 2000 });
                    setTimeout(() => {
                        apiRef.current?.updateRows([{
                        ...row,
                            whisper: whisper,
                        }]);
                        onClose();
                        }, 2100);
                    }
                },
              },
            }}
          >
            <DialogTitle><h3 style={{fontSize: '16px', fontWeight: 'bold'}}>Edit Whisper</h3></DialogTitle>
            <DialogContent>
                <ToastContainer position='top-center'/>
                <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginTop: 2, marginBottom: 2 }}>
                    <Typography variant="body1" sx={{ fontSize: '1rem', fontWeight: 'bold', marginRight: 1 }}>Customer assigned: </Typography>
                    <Typography variant="body1" sx={{ fontSize: '1rem' }}>{rowData['customer_name']} ({rowData['cust_id']})</Typography>
                </Box>
                <DialogContentText sx={{ marginBottom: 1 }}>
                    Update the whisper text here.
                </DialogContentText>
                <TextField
                    autoFocus
                    required
                    multiline
                    rows={6}
                    id="whisper"
                    name="whisper"
                    label="Whisper (max 300 characters)"
                    type="text"
                    fullWidth
                    variant="standard"
                    error={rowData.whisper?.length > 300 || rowData.whisper?.length === 0 ? true : false}
                    helperText={rowData.whisper?.length > 300 ? 'The whisper text must not be more than 300 characters long' : rowData.whisper?.length === 0 ? 'The whisper text is required' : ''}
                    value={rowData.whisper || ''}
                    onChange={(e) => setRowData({ ...rowData, whisper: e.target.value as string })}
                />
                </DialogContent>
                <DialogActions>
                <Button sx={{textTransform: 'capitalize', border: 0, boxShadow: 'none'}} onClick={onClose}>Cancel</Button>
                <Button type="submit" sx={{textTransform: 'capitalize', border: 0, boxShadow: 'none'}}>Update</Button>
                </DialogActions>
          </Dialog>
    )
}